import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Badge, Card, Table, Button } from "reactstrap";

export default function RecentTemplates(props) {
  const { recentTemplate = [],loading } = props;

  return (
    <Fragment>
      <div className="page-title">
        <h4>Pending Template</h4>

        <div className="top-btn">
          <Link   to={{
              pathname: "/admin/templates",
            }}>
          <Button size="sm" color="primary">
            See all
          </Button>
          </Link>
        </div>
      </div>
      <Card body className="mt-4">
        <Table hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>License Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading?"":recentTemplate.length === 0
              ?<tr><td colSpan={5} ><center>No Record found</center></td></tr> 
              : recentTemplate.map((data) => {
                  const {
                    templateId,
                    agencyName,
                    licenseName,
                    templateStatus,
                  } = data;
                  return (
                    <tr key={templateId}>
                      <td>{agencyName}</td>
                      <td>{licenseName}</td>
                      <td>
                        <Badge color="warning" className="badge-warning-soft">
                          {templateStatus}
                        </Badge>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </Table>
      </Card>
    </Fragment>
  );
}
